import React from "react";
import { Modal } from "react-bootstrap";
import ImportCsvFiles from "../../../pages/ImportCsvFiles";

const CustomImportFileModal = ({
  show,
  hide,
  heading,
  icon,
  mapArray,
  csvTitle,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => hide(false)}
      centered
      className="import-modal-dialog"
    >
      <Modal.Header closeButton className="gap-1">
        {/* <div className="d-flex align-items-center"> */}
        {/* {icon} */}
        <Modal.Title className="text-center fw-bold ms-1 flex-fill">
          {heading}
        </Modal.Title>
        {/* </div> */}
      </Modal.Header>
      <Modal.Body>
        <ImportCsvFiles
          csvTitle={csvTitle}
          title={heading}
          mapArray={mapArray}
          hide={hide}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CustomImportFileModal;
